<div class="container">

    <div style="display: flex; justify-content: flex-end; margin-bottom: 2%;">
        <button class="noPrint print-btn mr-2" printSectionId="print-section" ngxPrint [useExistingCss]="true">
            Print
        </button>
        <button mat-dialog-close (click)="dialogRef.close()" class=" btn noPrint">Close</button>
    </div>

    <!-- Filter -->
    <div class="filter-container">
        <div class="filter-card">

            <div class="filter-group">
                <label>Issue Month</label>
                <input type="text" placeholder="MM-YYYY (e.g. 02-2026)" [(ngModel)]="issueMonth" />
            </div>

            <div class="filter-actions">
                <button (click)="getLekhReport()">
                    📄 Load Report
                </button>
            </div>

        </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="loading-center">
        Loading report...
    </div>

    <!-- Error -->
    <div *ngIf="errorMsg" class="error">
        {{ errorMsg }}
    </div>

    <!-- Table -->
    <div class="table-wrapper" *ngIf="reportData.length > 0 && !loading" id="print-section">
        <h1 class="text-center my-5">Lekh Report</h1>
        <table>
            <thead>
                <tr>
                    <th>Sr.No.</th>
                    <th>Name</th>
                    <th>Mobile</th>
                    <th>Issue Name</th>
                    <th>Issue Month</th>
                    <th>Issue Start Date</th>
                    <th>Issue End Date</th>
                    <th>Rate</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let row of reportData; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ row.name }}</td>
                    <td>{{ row.mobile }}</td>
                    <td>{{ row.issue_name }}</td>
                    <td>{{ row.issue_month }}</td>
                    <td>{{ row.period_start_date | date:'yyyy-MM-dd' }}</td>
                    <td>{{ row.period_end_date | date:'yyyy-MM-dd' }}</td>
                    <td>{{ row.rate }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- No Data -->
    <div *ngIf="!loading && reportData.length === 0 && !errorMsg" class="no-data-center">
        No records found
    </div>

</div>